function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24,
  r: 24,
  fill: "#E9FAFA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.074 31.407L26.498 16.5h1.428l-5.424 14.907h-1.428zM14.509 23.232l-.009-.007v1.455l.009-.005 6.241 3.603v-1.441l-4.991-2.883 4.991-2.882v-1.444l-6.241 3.604zM28.25 21.072l4.991 2.882-4.991 2.883v1.44l6.241-3.602.009.005v-1.455l-.009.007-6.241-3.604v1.444z",
  fill: "#48DDDD"
});

function SvgCodeTrigger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCodeTrigger;